import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BalancerRunStatusQueryCgResponse,
  BalancerRunStatusQueryVariables,
} from '@common/graphql';

// Status poll for a single balancer run, behind the schedule-generation loading screen
// (WORK-6302). After "Confirm & Generate Schedules" fires `regenerateScheduleRun`, the page
// polls this with the returned run uuid until `state` reaches a reviewable value (or `failed`),
// then dismisses the loader. The run is scoped to the service line server-side, with no state
// filter, so the pending/running window is observable (unlike the review grid's reviewable_for).
export const BALANCER_RUN_STATUS_QUERY: TypedDocumentNode<
  BalancerRunStatusQueryCgResponse,
  BalancerRunStatusQueryVariables
> = gql`
  query BalancerRunStatus($balancerRunId: ID!, $serviceLineId: ID!) {
    balancerRunStatus(
      balancerRunId: $balancerRunId
      serviceLineId: $serviceLineId
    ) {
      uuid
      state
    }
  }
`;
